import { defineMessages } from "react-intl";

import { validator } from "lib/build/forms/htx/current-cardiological-state/vitalSigns";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	vitalSigns: {
		id: "form.vital_signs",
		defaultMessage: "Vitális paraméterek"
	},
	systolicBloodPressure: {
		id: "form.vital_signs.systolic_blood_pressure",
		defaultMessage: "Szisztolés vérnyomás"
	},
	diastolicBloodPressure: {
		id: "form.vital_signs.diastolic_blood_pressure",
		defaultMessage: "Diasztolés vérnyomás"
	},
	heartRate: {
		id: "form.vital_signs.heart_rate",
		defaultMessage: "Pulzus"
	}
});

const fields: { [key: string]: FieldData } = {
	systolicBloodPressure: {
		type: "field",
		path: ["systolicBloodPressure"],
		label: messages.systolicBloodPressure,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	diastolicBloodPressure: {
		type: "field",
		path: ["diastolicBloodPressure"],
		label: messages.diastolicBloodPressure,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	heartRate: {
		type: "field",
		path: ["heartRate"],
		label: messages.heartRate,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.systolicBloodPressure }] },
		{ columns: [{ width: 12, field: fields.diastolicBloodPressure }] },
		{ columns: [{ width: 12, field: fields.heartRate }] }
	]
};

export const node: LeafNode = {
	id: "vitalSigns",
	value: {
		title: messages.vitalSigns,
		validator,
		fieldset,
		applyCurrentDate: true,
		isImportant: true
	}
};
